module.exports = __webpack_public_path__ + "static/media/poppins-v15-latin-900.3d0ca9d2.svg";